import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown, X, Check } from 'lucide-react';
interface MultiSelectProps {
  label: string;
  options: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
}
export function MultiSelect({
  label,
  options,
  selected,
  onChange
}: MultiSelectProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [open]);
  const toggle = (option: string) => {
    if (selected.includes(option)) {
      onChange(selected.filter(s => s !== option));
    } else {
      onChange([...selected, option]);
    }
  };
  const clear = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange([]);
  };
  const hasSelection = selected.length > 0;
  const displayLabel = hasSelection ? selected.length === 1 ? selected[0] : `${label} (${selected.length})` : label;
  return <div className="relative" ref={ref} data-id="element-128">
      <button type="button" onClick={() => setOpen(v => !v)} className={`flex items-center gap-2 px-4 py-2 border rounded-lg hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-brand-orange-500 bg-white text-sm ${hasSelection ? 'border-brand-orange-500 bg-brand-orange-50 text-brand-orange-700' : 'border-slate-300 text-slate-700'}`} data-id="element-129">
        <span className="whitespace-nowrap" data-id="element-130">{displayLabel}</span>
        {hasSelection ? <span role="button" tabIndex={0} onClick={clear} className="p-0.5 rounded hover:bg-slate-200" data-id="element-131">
            <X className="w-3 h-3 text-slate-600" data-id="element-132" />
          </span> : <ChevronDown className="w-4 h-4 text-slate-500" data-id="element-133" />}
      </button>

      {open && <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-slate-200 rounded-lg shadow-lg z-20 py-1 max-h-64 overflow-y-auto" data-id="element-134">
          {options.map(option => {
        const isSelected = selected.includes(option);
        return <button key={option} type="button" onClick={() => toggle(option)} className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-50" data-id="element-135">
                <span className={`w-4 h-4 rounded border flex items-center justify-center flex-shrink-0 ${isSelected ? 'bg-brand-orange-500 border-brand-orange-500' : 'border-slate-300 bg-white'}`} data-id="element-136">
                  {isSelected && <Check className="w-3 h-3 text-white" data-id="element-137" />}
                </span>
                <span className="truncate" data-id="element-138">{option}</span>
              </button>;
      })}
        </div>}
    </div>;
}